import type { ComputedInset } from "@skilitics/drag-drop";

import type { SlotId } from "../../internal.ts";
import type { DND_CREATABLE_ID, DND_TEMPLATE_ID } from "./dndConstants.ts";

export const canvasEventTypes = {
  CREATE_CANVAS_CHILD_NODE: "CREATE_CANVAS_CHILD_NODE",
  IMPORT_TEMPLATE_AS_CHILD_NODE: "IMPORT_TEMPLATE_AS_CHILD_NODE",
  UPDATE_CANVAS_NODE_POSITION: "UPDATE_CANVAS_NODE_POSITION",
};

export type DndPositionUpdateEventOptions = {
  nodeId: number;
  delta: { x: number; y: number };
  computedInset: ComputedInset;
  scale: number;
};

type Create = {
  type: typeof DND_TEMPLATE_ID | typeof DND_CREATABLE_ID;
  typeId: string;
  templateId?: number;
  definitionId?: string;
} & (
  | {
      type: typeof DND_CREATABLE_ID;
    }
  | {
      type: typeof DND_TEMPLATE_ID;
      templateId: number;
    }
);

export type DndCreateEventOptions = {
  targetNodeId: number;
  create: Create;
  index?: number;
};

export type DragEndAddEvent = {
  eventType: "add";
  targetNodeId: number;
  create: Create;
  index?: number;
};

export type DragEndMoveEvent = {
  eventType: "move";
  nodeId: number;
  from: SlotId;
  to: SlotId;
};

export type DragEndReorderEvent = {
  eventType: "reorder";
  nodeId: number;
  index: number;
};

export type DragEndPositionEvent = {
  eventType: "position";
  nodeId: number;
  delta: { x: number; y: number };
  computedInset: ComputedInset;
};

export type DragEndEventResult =
  | DragEndAddEvent
  | DragEndMoveEvent
  | DragEndReorderEvent
  | DragEndPositionEvent
  | undefined;
